module.exports = __webpack_public_path__ + "img/工程机械行业结构示意图.50d855d8.jpg";